import ios from '../../dist/ionicons/svg/ios-send.svg';
import md from '../../dist/ionicons/svg/md-send.svg';
export default
/*#__PURE__*/
{
  ios: ios,
  md: md
};